import styled, { css } from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import Check from '@panel/commons/assets/icons/Check.svg';
import AlertIcon from '@panel/commons/assets/icons/AlertNotify.svg';
import AlertIconGrey from '@panel/commons/assets/icons/AlertTriangleGrey.svg';

const PostingContainer = styled.div`
  height: fit-content;
  width: 100%;
  border-radius: 8px;
  box-shadow: 5px 4px 32px 2px rgba(196, 196, 196, 0.2);
  display: flex;
  border: 1px solid ${select('middleGray')};
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  ${({ postingChecked, device }) =>
    postingChecked &&
    device !== 'tablet' &&
    css`
      box-shadow: 5px 4px 32px 2px rgba(196, 196, 196, 0.8);
    `}
  ${({ device }) =>
    device === 'tablet' &&
    css`
      box-shadow: none;
      border-radius: 0px;
    `}
`;

const CardContainer = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  height: ${({ device }) => (device === 'tablet' ? '184' : '178')}px;
  flex-direction: column;
`;
const ImageDefault = styled.div`
  background-color: ${select('grayMedium')};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 108px;
  height: 96px;
  border-radius: 8px;
`;

const ImageWrapper = styled.div`
  border-radius: 8px;
  position: relative;
  margin-left: '37px';
  > img {
    width: 108px;
    height: 96px;
    border-radius: 8px;
    object-fit: cover;
  }
  .img-hover {
    position: absolute;
    width: 108px;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0000006b;
    color: white;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    opacity: 0;
    cursor: pointer;
    text-decoration: none;
  }
  :hover {
    .img-hover {
      opacity: ${({ device }) => (device === 'tablet' ? 0 : 1)};
    }
  }
`;

const Reservado = styled.div`
  height: 18px;
  width: 71px;
  border-radius: 23px;
  padding: 0px 8px;
  position: absolute;
  top: 6px;
  left: 6px;
  background-color: ${select('negative')};
  color: ${select('white')};
  text-align: center;
  font-family: 'Hind';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
`;

const InfoLeftArea = styled.div`
  width: ${({ device }) => (device === 'tablet' ? 'fit-content' : '380px')};
  padding-right: 16px;
  margin-left: 16px;
  /* ${withQuery.lg.down()} {
    width: 230px;
    margin-left: 12px;
    padding-right: 10px;
  } */
  border-right: ${({ showEndedReasons }) => `1px solid ${select(showEndedReasons ? 'white' : 'grayMedium')}`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .address {
    font-size: 12px;
    font-weight: 500;
    color: ${select('midDarkGray')};
  }
`;

const InfoLabelsWrapper = styled.div`
  position: relative;
  > div {
    font-family: 'Hind';
    /* ${withQuery.lg.down()} {
      max-width: 100%;
    } */
    overflow: hidden;
    text-overflow: ellipsis;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .posting-title-wrapper {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: ${({ device }) => (device === 'tablet' ? '195' : '290')}px;
  }
`;

const InfoLabel = styled.div`
  font-size: ${props => (props.size ? props.size : '12px')};
  font-weight: ${props => (props.bold ? '600' : '500')};
  color: ${props => (props.darkGray ? select('darkGray') : select('black'))};
  > span {
    font-weight: 500;
  }
`;

const PostingTitle = styled.a`
  font-size: 14px;
  font-weight: 400;
  color: ${select('black')};
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ hasClonedPosting }) =>
    hasClonedPosting &&
    css`
      text-decoration: underline;
      cursor: pointer;
    `}
`;

const InfoRightArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
`;

const ProgressInfo = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  > div {
    position: absolute;
    font-family: 'Hind';
    font-size: 12px;
    text-align: center;
    top: 25%;
    left: ${props => (props.quality < 100 ? '25%' : '20%')};
  }
  &.POSTING-QUALITY-MOBILE {
    width: 90px;
    height: 90px;
    > div {
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      top: 30%;
      left: ${props => (props.quality < 100 ? '30%' : '28%')};
    }
  }
`;

const ProgressCircle = styled.svg`
  width: 40px;
  height: 40px;
  &.POSTING-QUALITY-MOBILE {
    width: 90px;
    height: 90px;
  }
`;

const CircleBackground = styled.circle`
  stroke-width: 4px;
  stroke: ${select('middleGray')};
  fill: transparent;
  r: 18px;
  cx: 20px;
  cy: 20px;

  &.POSTING-QUALITY-MOBILE {
    stroke-width: 8px;
    r: 41px;
    cx: 45px;
    cy: 45px;
  }
`;

const CircleProgression = styled.circle`
  stroke: ${select('blue')};
  stroke-dasharray: ${props =>
    `${(113 * props.completePercentage) / 100}px ${113 - (113 * props.completePercentage) / 100}px`};
  fill: transparent;
  stroke-width: 4px;
  r: 18px;
  cx: 20px;
  cy: 20px;

  &.POSTING-QUALITY-MOBILE {
    stroke-width: 8px;
    stroke-linecap: round;
    stroke-dasharray: ${props =>
      `${(258 * props.completePercentage) / 100}px ${258 - (258 * props.completePercentage) / 100}px`};
    r: 41px;
    cx: 45px;
    cy: 45px;
  }
`;

const GeneralCheckDropdown = styled.div`
  height: 48px;
  width: ${({ width }) => `${width}px`};
  border-radius: 8px;
  border: 1px solid ${select('midLightGray')};
  background-color: ${select('white')};
  border-color: ${props => props.active && select('orange')};
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  justify-self: ${({ device }) => device === 'tablet' && 'flex-end'};
  > button {
    background-image: ${props => (!props.active ? `url(${ChevronDown})` : `url(${ChevronUp})`)};
  }
  position: relative;
  > div {
    &:last-of-type {
      display: ${props => !props.active && 'none'};
    }
  }
`;

const FilterButton = styled.div`
  height: 48px;
  width: 50px;
  border-radius: 8px;
  border: 1px solid ${select('midLightGray')};
  background-color: ${select('white')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  justify-self: flex-end;
`;

const DropdownButton = styled.button`
  width: 12px;
  height: 12px;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 4px;
  cursor: pointer;
`;

const DropDownCheckList = styled.div`
  min-height: 212px;
  min-width: ${props => props.size && props.size};
  border-radius: 8px;
  border: 1px solid ${select('midLightGray')};
  background-color: ${select('white')};
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 900;
  top: 52px;
  left: ${({ device }) => (device !== 'tablet' ? '0px' : '-85px')};
  padding-top: 10px;
  > div {
    padding-left: ${props => props.smallPadding && '16px'} !important;
  }
`;

const DropdownOption = styled.div`
  padding-bottom: 10px;
  font-family: 'Hind';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding-left: 38px;
  cursor: pointer;
  &.DROPDOWN-OPTIONS-TITLE {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 25px;
  }
  &.SEARCHBAR-DROP-SELECTED {
    font-weight: 600;
    padding-left: 12px;
    &::before {
      content: ${`url(${Check})`};
      width: 16px;
      height: 16px;
      vertical-align: sub;
      margin-right: 10px;
    }
  }
`;

const AlertContainer = styled.div`
  margin-bottom: 30px;
`;

const LeftArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0 16px 16px;
  .checkbox-container {
    margin-right: 16px;
  }
`;

const ReportContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${select('redBack')};
  height: 30px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  ${({ hasUncheckedReport }) =>
    !hasUncheckedReport &&
    css`
      background-color: ${select('grayMedium')};
    `}

  ${({ device }) =>
    device === 'tablet' &&
    css`
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    `}
`;

const Alert = styled.div`
  background-image: ${({ hasUncheckedReport }) => `url(${hasUncheckedReport ? AlertIcon : AlertIconGrey})`};
  background-size: contain;
  background-repeat: no-repeat;
  width: 15px;
  height: 15px;
  margin: 0 8px;
`;

const ReportMessage = styled.div`
  font-size: 12px;
  font-family: 'Hind';
  color: ${select('negative')};
  display: flex;
  > button {
    margin-left: 4px;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
  ${({ hasUncheckedReport }) =>
    !hasUncheckedReport &&
    css`
      color: ${select('grayDark')};
    `}
`;

const stateFontColors = {
  ONLINE: 'snackGreen',
  DRAFT: 'darkGray',
  NEAR_END: 'brownYellow',
  OFFLINE: 'negative',
  WITHOUT_CREDIT: 'negative'
};

const PostingStateLabel = styled.div`
  display: inline-block;
  color: ${props => select(stateFontColors[props.estado])};
  text-align: center;
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  ::before {
    background-color: ${props => select(stateFontColors[props.estado])};
    display: inline-block;
    margin-right: 4px;
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: relative;
    bottom: 1.3px;
  }
  &.POSTING-STATE-TABLET {
    max-width: 65px;
  }
`;

const TypeAndStateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  width: 100%;
  margin-bottom: 11px;
`;

const DescriptionArea = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: initial !important;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      min-width: 268px;
    `};
`;

const PostingFooter = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 16px 0px 48px;
  border-top: 1px solid ${select('grayMedium')};
`;

const PostingBody = styled.div`
  display: flex;
`;

const FinishReasonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BannerFull = styled.div`
  width: 100%;
  height: 28px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: ${({ isDraft }) => select(isDraft ? 'draftFull' : 'violeti24Full')};
  color: ${select('white')};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  margin: 0 !important;
  p {
    font-family: Hind;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
  a {
    font-family: Hind;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    color: ${select('white')};
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 17px;
  }
`;

const TagZonaDemand = styled.div`
  display: inline-flex;
  max-width: 250px;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: ${select('middleGray')};
  color: ${select('black')};
  margin-right: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export {
  PostingContainer,
  ImageWrapper,
  InfoLeftArea,
  InfoLabelsWrapper,
  InfoLabel,
  InfoRightArea,
  ProgressInfo,
  ProgressCircle,
  CircleBackground,
  CircleProgression,
  GeneralCheckDropdown,
  DropdownButton,
  DropDownCheckList,
  DropdownOption,
  Reservado,
  FilterButton,
  AlertContainer,
  LeftArea,
  ReportContainer,
  CardContainer,
  Alert,
  ReportMessage,
  PostingStateLabel,
  TypeAndStateContainer,
  PostingTitle,
  DescriptionArea,
  PostingFooter,
  PostingBody,
  ImageDefault,
  FinishReasonsContainer,
  BannerFull,
  TagZonaDemand
};
